import { Injectable } from '@angular/core';
import { RateFileOptions } from 'app/types/rating.types';
import { Observable } from 'rxjs';
import { TrinityService } from 'app/services/trinity/trinity.service';

@Injectable({
  providedIn: 'root',
})
export class RatingService {
  private readonly apiEndpoint: string = '/rating';

  constructor(private trinityService: TrinityService) {}

  rateFile(options: RateFileOptions): Observable<void> {
    const res = this.trinityService.post<void>(
      `${this.apiEndpoint}/${options.file_id}`,
      {
        body: { rating: options.rating },
        authorized: true,
      },
    );

    return res;
  }
}
